<div class="jb-secondary-nav-block-list-container">
  <div class="jb-max-width center page-margin mb6 mb8-ns mb9-l jb-secondary-nav-block-list">
    <!-- Secondary navigation blocks component -->
    <jb-secondary-nav-block-list jbSitemapNestedLinker [navBlocks]="navBlocks">
    </jb-secondary-nav-block-list>
  </div>
</div>
